import { render, staticRenderFns } from "./LooksEditPage.vue?vue&type=template&id=2b5136d2&scoped=true&"
import script from "./LooksEditPage.vue?vue&type=script&lang=ts&"
export * from "./LooksEditPage.vue?vue&type=script&lang=ts&"
import style0 from "./LooksEditPage.vue?vue&type=style&index=0&id=2b5136d2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b5136d2",
  null
  
)

export default component.exports